import {
  Box,
} from '@mui/material';
import {styled} from '@mui/system';

export const EventInfoContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  margin: '0px 0px 12px',
  [theme.breakpoints.down('sm')]: {
    margin: '16px 0px 0px',
  },
}));
